import axios from 'axios'

const qs = require('qs')

const state = {
  categoriesList: [],
  categoriesSingle: null,
  isLoading: false,
}

const getters = {
  getCategoriesList (state) {
    return state.categoriesList
  },
  getCategoriesSingle (state) {
    return state.categoriesSingle
  },
  isLoadingCategories (state) {
    return state.isLoading
  },
}

const mutations = {
  setCategoriesList (state, payload) {
    state.categoriesList = payload
  },
  setCategoriesSingle (state, payload) {
    state.categoriesSingle = payload
  },
  clearCategoriesSingle (state) {
    state.categoriesSingle = null
  },
  loadingStart (state) {
    state.isLoading = true
  },
  loadingFinish (state) {
    state.isLoading = false
  },
}

const actions = {
  fetchFilialMenuCategoriesList ({ commit, rootGetters }, meta) {
    commit('loadingStart')
    const params = qs.stringify(meta, { arrayFormat: 'repeat', addQueryPrefix: true })
    return axios
      .get(`${rootGetters['api/filialMenuCategoriesList']}${params}`)
      .then((res) => {
        commit('setCategoriesList', res.data.items)
        commit('loadingFinish')

        return res
      })
      .finally(() => {
        commit('loadingFinish')
      })
  },
  fetchFilialMenuSingleCategories ({ commit, rootGetters }, { id, meta }) {
    commit('loadingStart')
    return axios
      .get(`${rootGetters['api/filialMenuCategoriesSingle'](id)}`, {
        params: meta,
      })
      .then((res) => {
        commit('setCategoriesSingle', res.data.data)
        commit('loadingFinish')
        return res
      })
      .catch((err) => {
        commit('loadingFinish')
        return err
      })
  },
  fetchCategoriesList ({ commit, rootGetters }, meta) {
    commit('loadingStart')
    const params = qs.stringify(meta, { arrayFormat: 'repeat', addQueryPrefix: true })
    return axios
      .get(`${rootGetters['api/categoriesList']}${params}`)
      .then((res) => {
        commit('setCategoriesList', res.data.items)
        commit('loadingFinish')

        return res
      })
      .finally(() => {
        commit('loadingFinish')
      })
  },
  fetchSingleCategories ({ commit, rootGetters }, { id, meta }) {
    commit('loadingStart')
    return axios
      .get(`${rootGetters['api/categoriesSingle'](id)}`, {
        params: meta,
      })
      .then((res) => {
        commit('setCategoriesSingle', res.data.data)
        commit('loadingFinish')
        return res
      })
      .catch((err) => {
        commit('loadingFinish')
        return err
      })
  },
  createCategories ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/categoriesCreate'], data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  editCategories ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/categoriesEdit'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  deleteCategories ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/categoriesDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getBranches.filter((val) => val.id !== id)
          commit('setCategoriesList', items)
        }

        return res
      })
      .catch((err) => err)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
